import { render } from "./add-secret-key-sidebar.vue?vue&type=template&id=e94ff948&ts=true"
import script from "./add-secret-key-sidebar.ts?vue&type=script&lang=ts"
export * from "./add-secret-key-sidebar.ts?vue&type=script&lang=ts"

import "./add-secret-key-sidebar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__